import dayjs from 'dayjs';
import cn from 'classnames';
import { useReactiveVar } from '@apollo/client';
import { UiButton, UiIcon, UiProgress, UiText } from 'znanie-uikit';

import { IRegistrationProps, isMoreAvailableSeats } from './index';

import { eventRegisterBtnStateVar } from 'store/eventRegisterBtnState';

import { decl } from 'utils/helpers';
import { AnalyticsEvent, trackAnalyticsData } from 'utils/analytics';

import css from './Registration.module.scss';

interface IProps extends Omit<IRegistrationProps, 'broadcasts'> {}

export default function OfflineEventRegistration({
  enrollFinishDate,
  isOffline,
  isUserRegistered,
  eventId,
  left,
  capacity,
  onSignUpClick,
}: IProps) {
  const { isDisabled } = useReactiveVar(eventRegisterBtnStateVar);

  const progressPercent = (1 - (capacity - left) / capacity) * 100;

  const getProgressColor = () => {
    if (progressPercent > 70) {
      return '#54C6F2';
    } else if (progressPercent < 30) {
      return '#ed694a';
    } else {
      return '#fec42d';
    }
  };

  const handleOtherEventsBtnClick = () => {
    trackAnalyticsData(AnalyticsEvent.EVENT_OTHER_EVENTS_BTN_CLICK);
  };

  return (
    <>
      <div className={css.info}>
        {isMoreAvailableSeats({ capacity, left }) && (
          <>
            <UiText align="center">
              Осталось{' '}
              <UiText className={css.count} as="span">
                {left}
              </UiText>{' '}
              {decl(left, ['место', 'места', 'мест'])}
            </UiText>
            <div className={css.progress}>
              <UiProgress
                percent={progressPercent}
                color={getProgressColor()}
              />
            </div>
          </>
        )}
        <UiText align="center" className={css.expireDate}>
          Запись до {dayjs(enrollFinishDate).format('DD MMMM HH:mm')}
        </UiText>
      </div>
      <div className={cn(css.buttons, !isOffline && css.buttonsReverse)}>
        {isUserRegistered ? (
          <UiButton
            fluid
            variant="outline"
            className={css.btnOffset}
            href="#map"
          >
            Место проведения
          </UiButton>
        ) : left > 0 ? (
          <UiButton
            fluid
            variant="primary"
            weight="normal"
            className={css.btnOffset}
            disabled={isDisabled}
            onClick={onSignUpClick}
          >
            Записаться
          </UiButton>
        ) : (
          <UiButton
            fluid
            variant="outline"
            className={css.btnOffset}
            href="/events"
            onClick={handleOtherEventsBtnClick}
          >
            Другие мероприятия
          </UiButton>
        )}
        {
          // Отображаем кнопку "Добавить в календарь",
          // если пользователь зарегистрирован на текущее мероприятие
          isUserRegistered && (
            <UiButton
              className={!isOffline ? css.btnOffset : ''}
              fluid
              startIcon={<UiIcon name="calendar" size={18} />}
              weight="normal"
              variant="outline"
              href={`${process.env.NEXT_PUBLIC_API_HOST}/api/event-calendar/${eventId}/cal.ics`}
              target="_blank"
            >
              Добавить в календарь
            </UiButton>
          )
        }
      </div>
    </>
  );
}
